export default __webpack_public_path__ + "img/620d25a97c66b932fbced566c4ddd014.png";